import * as React from "react"
import logo from "./Lucas_Santos_logo.webp"

const Logo = () => (
  <img src={logo} alt="logo" width={150} height={150} />
)

export default Logo
